import script from "./LegalListView.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalListView.vue?vue&type=script&setup=true&lang=js"

import "./LegalListView.vue?vue&type=style&index=0&id=5e0715f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0715f8"]])

export default __exports__